import firebase, { initializeApp } from 'firebase/app';
// import { getAnalytics } from 'firebase/analytics';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectDatabaseEmulator, getDatabase } from 'firebase/database';
import { connectStorageEmulator, getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
// import { getMessaging, getToken } from 'firebase/messaging';

// TODO: - Move keys to ENV variables
const firebaseConfig = {
  apiKey: 'AIzaSyDBDLo3BhnOIeFHWVFQIPATxCWbO802sW0',
  authDomain: 'away-885d7.firebaseapp.com',
  projectId: 'away-885d7',
  databaseURL: 'https://away-885d7-default-rtdb.firebaseio.com/',
  storageBucket: 'away-885d7.appspot.com',
  messagingSenderId: '1062375056447',
  appId: '1:1062375056447:web:6c35a3af9b93db5258848a',
  measurementId: 'G-67N4RRT2VJ',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const functions = getFunctions(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);
export const database = getDatabase(app);

// export const db = getDatabase(app);
// export const messaging = getMessaging(app);
// export const analytics = getAnalytics(app);

// getToken(messaging, {
//   vapidKey:
//     'BFW5j59e6U-nFxq4wdFt1cLEmZy-OJGCidhxe_RUjR-i6ev4JcQAsb_DwCxwYKHG_RBWrLTf6XydDQ5FM6plTkM',
// });

// ! Emulator Setup for Local Testing (Overrides the Real Firestore Instance in the Cloud)
// connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
// connectDatabaseEmulator(database, '127.0.0.1', 9000);
// connectStorageEmulator(storage, '127.0.0.1', 9199);
// connectAuthEmulator(auth, 'http://127.0.0.1:9099');
// connectFunctionsEmulator(functions, '127.0.0.1', 5001);

// ^
// TODO: - Not supported by RN, not dire but alternative for later:
// https://docs.expo.dev/versions/latest/sdk/firebase-analytics/

export default firebase;
